import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeOverlapResponse from "./chargeOverlapResponse";
import ChargeOverlapType from "./chargeOverlapType";
import RequestedChargeValidityResponse from "./requestedChargeValidityResponse";
import VehicleRegistrationResponse from "./vehicleRegistrationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeValidityOverlapInstructionsGroupResponse {
  @observable
  @Type(() => VehicleRegistrationResponse)
  vehicle!: VehicleRegistrationResponse;

  @observable
  @Type(() => RequestedChargeValidityResponse)
  requestedValidity!: RequestedChargeValidityResponse;

  /**
   * Price list item ID.
   */
  @observable
  priceListItemId!: string;

  /**
   * Charge overlaps.
   */
  @observable
  overlapTypes!: ChargeOverlapType[];

  /**
   * Existing overlapping charges - max 3 most relevant overlaps.
   */
  @observable
  @Type(() => ChargeOverlapResponse)
  overlappingCharges?: ChargeOverlapResponse[];
}
